{
  "title": "How to Assign Submissions to Judges",
  "description": "Batch-assign submitted submissions to judges to start the scoring process.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, each assigned judge sees these submissions in their own judge workspace and can start scoring.",
  "roleNote": "Competition Admin",
  "prerequisites": [
    "A rubric has been created and a version published",
    "Judges have been invited and confirmed",
    "Submissions have reached a judgeable stage"
  ],
  "pathLabel": "Organizer Dashboard → My Competition → Judge Invitations & Assignments → Assignments",
  "steps": [
    {
      "title": "1. Open the Assignments tab",
      "description": "From the competition, open \"Judge Invitations & Assignments\" and switch to the \"Assignments\" tab."
    },
    {
      "title": "2. Select submissions and judges",
      "description": "Select multiple submissions and multiple judges at once, choose one rubric version, and create assignments for every selected combination in a single action. You can also use \"Automatic balanced assignment\" at the top of the tab: choose the round, rubric and number of judges per submission, preview each judge's workload change and any submissions that cannot be fully covered, and only then create it."
    },
    {
      "title": "3. Submit the batch",
      "description": "The system attempts to create each \"submission x judge\" combination one by one; a duplicate assignment (the same judge already assigned to the same submission) or a combination blocked by a conflict of interest is automatically skipped and reported with a reason — it does not fail the whole batch."
    },
    {
      "title": "4. Review the results",
      "description": "The screen shows the list of successfully created assignments, plus which combinations were skipped and why (duplicate assignment / conflict of interest / the user isn't a judge for this competition)."
    }
  ],
  "afterward": [
    "Successfully assigned submissions appear in the matching judge's workspace",
    "Skipped combinations produce no assignment record at all",
    "You can track each judge's progress on the Scoring Progress view"
  ],
  "nextSteps": "Next, track scoring progress to see whether any assignments are still incomplete before the deadline.",
  "faq": [
    {
      "q": "If some combinations fail during a batch assignment, does the rest of the batch fail too?",
      "a": "No. The system skips duplicate or conflicted combinations one by one and reports the reason, without failing the rest of the batch because of a single failed combination — handle the reported reasons individually."
    },
    {
      "q": "Can I change a single assignment's judge or rubric version afterward?",
      "a": "Yes, an individual assignment that's still \"active\" can be edited; changing the rubric version on an assignment that already has a submitted score is generally not recommended."
    }
  ]
}
